// import Realm from "realm";
import TorneoType from "../types/TorneoType";
// import torneosMock from "../types/mocks/TorneosMock";

export default class TorneoHelper {
  public static getTorneos() {
    let torneosJson = localStorage.getItem('mus-torneos');
    if (torneosJson) {
      let torneos = JSON.parse(torneosJson);
      return torneos
    } else {
      return [];
    }
  }

  public static saveTorneos(torneos:  Array<TorneoType>) {
    let torneosJson = JSON.stringify(torneos);
    localStorage.setItem("mus-torneos", torneosJson);
    // Realm.open({schema: [{name: 'torneos', properties: {musTorneos: 'string'}}]}).then(
    //   realm => {
    //     realm.write(() => {
    //       realm.create('torneos', {torneosJson})
    //     })
    //     console.log('db path: ' + realm.path);
    // });
  }
}
